module.exports = __webpack_public_path__ + "static/media/libro12.f541aaf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro12.png
// module id = 360
// module chunks = 0